module.exports = __webpack_public_path__ + "static/img/poster.036647f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poster.png
// module id = ls1c
// module chunks = 0